import { BookOpen, GithubLogo, GlobeHemisphereWest, Info } from "@phosphor-icons/react";

export default function Help() {
  return (
    <div className="h-full overflow-auto px-10 py-10">
      <div className="max-w-3xl">
        <p className="label-micro text-[#FF9800] mb-2 flex items-center gap-2">
          <Info size={14} weight="bold" /> AYUDA
        </p>
        <h1 className="text-4xl font-bold tracking-tight">Cómo usar la plataforma</h1>

        <div className="mt-8 space-y-6 text-white/70 text-sm leading-relaxed">
          <section className="border-l-2 border-[#FF9800] pl-5">
            <h2 className="text-xl font-bold text-white mb-2">1 · Elige nivel de zonificación</h2>
            <p>Distritos para máxima resolución, Municipios para análisis intermedios, o GAU (Grandes Áreas Urbanas) para vista global.</p>
          </section>

          <section className="border-l-2 border-[#00E5FF] pl-5">
            <h2 className="text-xl font-bold text-white mb-2">2 · Selecciona orígenes y destinos</h2>
            <p>Usa el mapa (clic en cada punto) o el buscador. Cambia el modo de selección con el conmutador <span className="text-[#00E5FF]">Origen</span> / <span className="text-[#FF5722]">Destino</span> en la barra superior del mapa.</p>
          </section>

          <section className="border-l-2 border-[#FF5722] pl-5">
            <h2 className="text-xl font-bold text-white mb-2">3 · Aplica filtros</h2>
            <p>Fecha (cualquier día de 2022-2025), franja horaria, motivo del viaje, banda de distancia y modo. Cuanto más restrictivo el filtro, menor el volumen.</p>
          </section>

          <section className="border-l-2 border-white/40 pl-5">
            <h2 className="text-xl font-bold text-white mb-2">4 · Calcula y explora</h2>
            <p>Pulsa <span className="text-[#FF9800]">Calcular matriz</span>. La derecha muestra Matriz tabular, lista Flujos, Heatmap O/D y Gráficos. Descarga en CSV o guarda el análisis como proyecto.</p>
          </section>

          <section className="bg-[#121212] border border-white/10 p-5">
            <h3 className="font-bold text-white mb-2 flex items-center gap-2">
              <GlobeHemisphereWest size={18} className="text-[#FF9800]" /> Fuente de datos
            </h3>
            <p className="text-white/60 mb-2">
              Dos fuentes disponibles, seleccionables en el desplegable <span className="text-[#FF9800]">Fuente</span>:
            </p>
            <ul className="space-y-2 text-white/60 list-disc pl-5">
              <li>
                <span className="text-[#00E5FF]">MITMA real (CSV oficial)</span> — descarga el archivo
                <span className="font-mono mx-1 text-white">YYYYMMDD_Viajes_&#123;nivel&#125;.csv.gz</span>
                del mirror oficial y agrega los <span className="text-white">viajes</span> reales filtrando por
                origen/destino, periodo, distancia, motivo y demografía. La primera consulta de cada día tarda
                ≈ 25 s (descarga + parseo de ~24 M filas). Las consultas posteriores sobre la misma fecha
                aprovechan la caché y bajan a &lt; 1 s.
              </li>
              <li>
                <span className="text-[#FF9800]">Estimación gravitacional</span> — modelo determinista
                basado en población y distancia, útil para pruebas rápidas sin red. Respuesta instantánea.
              </li>
            </ul>
            <p className="text-white/40 text-xs mt-3">
              Cobertura real: 2022-01-01 → 2025-06-08 (1 153 días).
            </p>
          </section>

          <section className="bg-[#121212] border border-[#FFB74D]/30 p-5">
            <h3 className="font-bold text-[#FFB74D] mb-2 flex items-center gap-2">
              <Info size={18} /> Cuota de Google Drive
            </h3>
            <p className="text-white/60">
              Si ves el error <span className="font-mono text-[#FFB74D]">«No se pudo descargar el archivo MITMA»</span> al pedir un día nuevo, lo más probable es
              que Google Drive haya bloqueado temporalmente las descargas masivas del folder. Tres alternativas:
            </p>
            <ol className="list-decimal pl-5 mt-2 space-y-1 text-white/60">
              <li>Espera 24 h (la cuota se reinicia diariamente).</li>
              <li>Reintenta con otro día — los días ya cacheados siguen funcionando al instante.</li>
              <li>Como admin, sube el CSV.gz manualmente vía <span className="font-mono text-white">POST /api/data/upload?level=&amp;date=</span>.</li>
            </ol>
          </section>

          <section className="bg-[#121212] border border-white/10 p-5">
            <h3 className="font-bold text-white mb-2 flex items-center gap-2">
              <BookOpen size={18} className="text-[#00E5FF]" /> Recursos
            </h3>
            <ul className="space-y-2 text-white/60">
              <li>• Metodología MITMA: enlace en el portal oficial.</li>
              <li>• Procesado con Python: <span className="font-mono">pySpainMobility</span>.</li>
              <li>• Procesado con R: <span className="font-mono">spanishoddata</span>.</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}
